import {
  Box,
  Button,
  Container,
  Grid,
  HStack,
  Stack,
  Text,
  useMediaQuery,
  Wrap,
} from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";

import { useRef } from "react";
import { ArrowLeftCircle, ArrowRightCircle } from "react-feather";
import { useLocation, useNavigate } from "react-router-dom";
import ResourceWorkshopCard from "./resourceWorkshopCard";
import { VideoPlayerPage } from "./videoPlayerPage";

export const WorkshopVault = ({expanded, resourceData = null }) => {
  const [stepIndex, setStepIndex] = useState(0);
  const [isMobile] = useMediaQuery("(max-width: 1280px)");
  const [navOverlap] = useMediaQuery("(max-width: 1280px)", { ssr: false });
  const [hasOverflow, setHasOverflow] = useState(false);
  const scrollRef = useRef(null);
  const headerRef = useRef(null);

  const [toggleView, setToggleView] = useState(false);
  const [resource, setResource] = useState({});
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  const steps = useMemo(
    () => resourceData?.workshop_steps || [],
    [resourceData]
  );
  const selectedStep = steps[stepIndex] || null;

  const [headerHeight, setHeaderHeight] = useState(140);

  useEffect(() => {
    if (!headerRef.current) return;

    setHeaderHeight(headerRef.current.offsetHeight);

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setHeaderHeight(entry.contentRect.height);
      }
    });

    resizeObserver.observe(headerRef.current);

    return () => resizeObserver.disconnect();
  }, [resource]);

  const scrollTabs = (direction) => {
    if (!scrollRef.current) return;
    const scrollAmount = 150;
    scrollRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setIsMobileDevice(
      /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    );
  }, [setIsMobileDevice]);

  const location = useLocation();
  const navigate = useNavigate();

  const clearQueryString = () => {
    navigate(location.pathname);
  };

  const navigateRef = useRef(navigate);
  useEffect(() => {
    navigateRef.current = navigate;
  }, [navigate]);

  const searchRef = useRef(location.search);
  useEffect(() => {
    searchRef.current = location.search;
  }, [location.search]);

  useEffect(() => {
    if (!resource?.id) return;

    const currentParams = new URLSearchParams(searchRef.current);
    const currentId = currentParams.get("stepId");
    const newId = String(resource.id);

    if (currentId !== newId) {
      currentParams.set("stepId", newId);
      navigateRef.current({ search: currentParams.toString() });
    }

    setToggleView(true);
  }, [resource]);

  useEffect(() => {
    if (!resourceData) return;

    const params = new URLSearchParams(location.search);
    const stepId = params.get("stepId");

    if (stepId) {
      const stepResource = resourceData?.workshop_steps
        ?.flatMap((step) => step.step_resources)
        ?.find((res) => String(res.id) === stepId);

      if (stepResource) {
        setResource(stepResource);
        setToggleView(true);
        return;
      }
    }

    setResource(null);
    setToggleView(false);
  }, [resourceData, location.search]);

  useEffect(() => {
    const checkOverflow = () => {
      if (!scrollRef.current) return;
      const el = scrollRef.current;
      setHasOverflow(el.scrollWidth > el.clientWidth);
    };

    checkOverflow();

    const resizeObserver = new ResizeObserver(checkOverflow);
    if (scrollRef.current) resizeObserver.observe(scrollRef.current);

    return () => resizeObserver.disconnect();
  }, [steps, isMobile, navOverlap]);

  return (
    <Container
      width="100%"
      maxW="100%"
      bg="#F4F4F2"
      p="0px"
      position="relative"
      height={"100%"}
    >
      {toggleView && (
        <VideoPlayerPage
          resourceData={resource}
          setVault={setToggleView}
          isWorkshop={true}
          fullData={resourceData}
        />
      )}

      {!toggleView && (
        <Stack width="100%">
          <Box
            ref={headerRef}
            backgroundColor="#F4F4F2"
            position="fixed"
            zIndex={400}
            p={{
              base: "12px 24px",
              sm: "12px 24px",
              md: "22px 24px",
              lg: "24px 24px",
            }}
            width="100%"
            minWidth="100%"
            maxW="100%"
          >
            <Wrap>
              <Text
                fontSize={"16px"}
                fontWeight={400}
                color={"#2D3748"}
                onClick={clearQueryString}
                cursor={"pointer"}
                _hover={{
                  textDecoration: "underline",
                  textDecorationColor: "#2D3748",
                }}
              >
                Growth Tools
              </Text>
              <Text fontSize={"16px"} fontWeight={400} color={"#1A202C"}>
                {">"}
              </Text>
              <Text fontSize={"16px"} fontWeight={700} color={"#2D3748"}>
                {resourceData?.resource_title}
              </Text>
            </Wrap>
            <HStack pb="10px" width="100%" justifyContent="space-between">
              <Text
                fontWeight={700}
                fontSize={{ base: "20px", lg: "24px" }}
                pl="10px"
                py={{
                  base: "3px",
                  sm: "3px",
                  md: "3px",
                  lg: "10px",
                }}
              >
                {resourceData?.resource_title}
              </Text>

              {!isMobileDevice && hasOverflow && (
                <HStack
                  pr="10px"
                  mr={
                    !isMobile
                      ? expanded
                        ? navOverlap
                          ? "0px"
                          : "270px"
                        : "105px"
                      : "0px"
                  }
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="full"
                    transition="all 0.2s ease"
                    cursor="pointer"
                    _hover={{ bg: "gray.100", transform: "scale(1.05)" }}
                    _active={{ bg: "gray.200", transform: "scale(0.95)" }}
                    onClick={() => scrollTabs("left")}
                  >
                    <ArrowLeftCircle size={32} color="#536DEC" />
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    borderRadius="full"
                    transition="all 0.2s ease"
                    cursor="pointer"
                    _hover={{ bg: "gray.100", transform: "scale(1.05)" }}
                    _active={{ bg: "gray.200", transform: "scale(0.95)" }}
                    onClick={() => scrollTabs("right")}
                  >
                    <ArrowRightCircle size={32} color="#536DEC" />
                  </Box>
                </HStack>
              )}
            </HStack>

            <Grid
              templateColumns="1fr"
              width={
                isMobile
                  ? "100%"
                  : expanded
                  ? navOverlap
                    ? "100%"
                    : "calc(100% - 270px)"
                  : "calc(100% - 105px)"
              }
              height="100%"
            >
              <Box
                ref={scrollRef}
                overflowX="auto"
                whiteSpace="nowrap"
                flex="1"
                sx={{
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                <HStack as="div" spacing="24px">
                  {steps.map((step, index) => {
                    const isSelected = index === stepIndex;
                    return (
                      <Button
                        key={step.id}
                        flexShrink={0}
                        fontWeight={600}
                        padding="10px 15px"
                        borderRadius="md"
                        minW={"165px"}
                        height={"40px"}
                        fontSize={{ base: "14px", lg: "16px" }}
                        bg={isSelected ? "#536DEC" : "white"}
                        color={isSelected ? "white" : "black"}
                        _hover={{ bg: "#536DEC", color: "white" }}
                        onClick={() => setStepIndex(index)}
                      >
                        {step.label}
                      </Button>
                    );
                  })}
                </HStack>
              </Box>
            </Grid>
          </Box>

          <Stack
            mt={`${headerHeight + 40}px`}
            spacing="20px"
            p={"0px 24px 32px"}
          >
            <Stack spacing={"5px"}>
              <Text
                fontWeight={700}
                fontSize={{ base: "20px", lg: "24px" }}
                pl="10px"
              >
                {selectedStep?.title}
              </Text>
              <Text
                fontWeight={400}
                fontSize={{ base: "14px", lg: "16px" }}
                pl="10px"
                color={"#4A5568"}
              >
                {selectedStep?.description}
              </Text>
            </Stack>

            {selectedStep?.step_resources?.length > 0 ? (
              <Grid
                templateColumns={{
                  base: "1fr",
                  sm: "1fr 1fr",
                  lg: "1fr 1fr 1fr",
                }}
                gap="20px"
              >
                {selectedStep.step_resources.map((res) => (
                  <ResourceWorkshopCard
                    key={res.id}
                    tags={[]}
                    title={res.resource_title}
                    description={res.resource_description}
                    resourceVideoLink={res.external_link}
                    resourceLink={res.resource_file}
                    backgroundImage={res.card_image}
                    videoDuration={res.video_duration}
                    resourceData={res}
                    setSelectedResource={setResource}
                    toggleView={setToggleView}
                  />
                ))}
              </Grid>
            ) : (
              <Text pl="10px" fontWeight={500}>
                No resources in this step.
              </Text>
            )}
          </Stack>
        </Stack>
      )}
    </Container>
  );
};
